import * as React from 'react'
import styled from 'styled-components'
import Colors from '../../styles/Colors'

function FilterIcon(props: any) {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={16} height={12} viewBox="0 0 16 12" {...props}>
      <g data-name="Group 51268" fill="none" stroke="CurrentColor" strokeWidth={2}>
        <path data-name="Path 17321" d="M1817 163h-16M1814 168h-10M1811 173h-4" transform="translate(-1801 -162)" />
      </g>
    </Svg>
  )
}
const Svg = styled.svg`
  color: ${Colors.primaryBlack};
  -webkit-text-fill-color: rgba(0, 0, 0, 1);
  -webkit-opacity: 1;
`

export default FilterIcon
